import { Add } from './Add.js';
import { AiAnalytics } from './AiAnalytics.js';
import { AiAssistant } from './AiAssistant.js';
import { AiAssistantAlt } from './AiAssistantAlt.js';
import { AiGeneratedDoc } from './AiGeneratedDoc.js';
import { AiGeneratedDocAlt } from './AiGeneratedDocAlt.js';
import { AiSign } from './AiSign.js';
import { Analytics } from './Analytics.js';
import { Archived } from './Archived.js';
import { Bell } from './Bell.js';
import { Booked } from './Booked.js';
import { Calendar } from './Calendar.js';
import { Cancel } from './Cancel.js';
import { Catalogue } from './Catalogue.js';
import { CatalogueAlt } from './CatalogueAlt.js';
import { Chart } from './Chart.js';
import { Check } from './Check.js';
import { Clear } from './Clear.js';
import { Clock } from './Clock.js';
import { Company } from './Company.js';
import { CRMAlt1 } from './CRMAlt1.js';
import { CRMAlt2 } from './CRMAlt2.js';
import { Dashboard } from './Dashboard.js';
import { Database } from './Database.js';
import { Display } from './Display.js';
import { Document } from './Document.js';
import { Dollar } from './Dollar.js';
import { Draft } from './Draft.js';
import { Edit } from './Edit.js';
import { FastTranslate } from './FastTranslate.js';
import { Fire } from './Fire.js';
import { Gear } from './Gear.js';
import { Headphones } from './Headphones.js';
import { Hint } from './Hint.js';
import { HorizontalLayout } from './HorizontalLayout.js';
import { Image } from './Image.js';
import { Info } from './Info.js';
import { InProgress } from './InProgress.js';
import { Megaphone } from './Megaphone.js';
import { MouseCursor } from './MouseCursor.js';
import { Newspaper } from './Newspaper.js';
import { Offered } from './Offered.js';
import { Pause } from './Pause.js';
import { Payout } from './Payout.js';
import { Percentage } from './Percentage.js';
import { Person } from './Person.js';
import { PersonAdd } from './PersonAdd.js';
import { PersonRemove } from './PersonRemove.js';
import { Phone } from './Phone.js';
import { Photo } from './Photo.js';
import { Play } from './Play.js';
import { PlayAlt } from './PlayAlt.js';
import { Preview } from './Preview.js';
import { PreviewCrossed } from './PreviewCrossed.js';
import { Rectangle } from './Rectangle.js';
import { Remove } from './Remove.js';
import { Revenue } from './Revenue.js';
import { Rise } from './Rise.js';
import { Sales } from './Sales.js';
import { SettingsAlt } from './SettingsAlt.js';
import { Square } from './Square.js';
import { Tag } from './Tag.js';
import { Targeting } from './Targeting.js';
import { TemporaryUnavailable } from './TemporaryUnavailable.js';
import { Users } from './Users.js';
import { Warning } from './Warning.js';
export const FilledIcons = {
    Add,
    AiAnalytics,
    AiAssistant,
    AiAssistantAlt,
    AiGeneratedDoc,
    AiGeneratedDocAlt,
    AiSign,
    Analytics,
    Archived,
    Bell,
    Booked,
    Calendar,
    Cancel,
    Catalogue,
    CatalogueAlt,
    Chart,
    Check,
    Clear,
    Clock,
    Company,
    CRMAlt1,
    CRMAlt2,
    Dashboard,
    Database,
    Display,
    Document,
    Dollar,
    Draft,
    Edit,
    FastTranslate,
    Gear,
    Headphones,
    Hint,
    HorizontalLayout,
    Info,
    Image,
    InProgress,
    Megaphone,
    MouseCursor,
    Newspaper,
    Offered,
    Pause,
    Payout,
    Percentage,
    Person,
    PersonAdd,
    PersonRemove,
    Phone,
    Photo,
    Play,
    PlayAlt,
    Preview,
    PreviewCrossed,
    Rectangle,
    Remove,
    Revenue,
    Rise,
    Sales,
    SettingsAlt,
    Fire,
    Square,
    Tag,
    Targeting,
    TemporaryUnavailable,
    Users,
    Warning,
};
export default FilledIcons;
